<div class="layout">
  <div
    class="wrapper"
    [class.wrapper--reduced-width]="true">
    <a
      class="skip-link"
      href="#main-content"
      (click)="skipToMain($event)">
      Skip to main content
    </a>
    <mat-sidenav-container>
      <mat-sidenav
        [fixedTopGap]="0"
        fixedInViewport
        #mobileMenu
        mode="over"
        position="end"
        [autoFocus]="false"
        class="sidenav--right"
        (opened)="disableScroll()"
        (closed)="enableScroll()">
        <ng-container *ngTemplateOutlet="header" />
        <button
          class="header-menu-toggle__button"
          (click)="mobileMenu.toggle()">
          <cl-icon
            [icon]="Icon.cancel"
            size="44px" />
        </button>
      </mat-sidenav>
      <header
        class="header"
        id="site-header">
        <picture class="header__logo">
          <source
            srcset="{{mobileLogo}}"
            media="(max-width: 480px)" />
          <img
            [routerLink]="['/']"
            alt="Waterford logo"
            class="logo"
            src="{{ logo }}" />
        </picture>
        <div class="header--nav">
          <div
            class="header__logged-in-user"
            data-private
            id="logged-in-user">
            <ng-container *ngTemplateOutlet="UserNameBlock" />
          </div>
          <div class="header__logged-in-user__bottom">
            @if (orgCode$ | async; as orgCode) {
              <div class="header__logged-in-user__bottom__org-code">
                <div class="header__logged-in-user__bottom__org-code__label">
                  {{ 'Org Code:' | translate }}
                </div>
                <div class="header__logged-in-user__bottom__org-code__value">{{ orgCode }}</div>
              </div>
            }
            @if (showBell$ | async) {
              <cl-icon-badge
                [object]="false"
                [icon]="Icon.bellBlue"
                [notificationsCount]="bellItemCount$ | async"
                [routerLink]="['messages-and-notifications']"
                id="bell-button" />
            }

            <cl-btn
              (click)="logOut()"
              buttonStyle="small"
              [id]="'logout-button'">
              {{ 'Logout' | translate }}
            </cl-btn>
          </div>
        </div>
        <div class="header-menu-toggle">
          <button
            class="header-menu-toggle__button"
            (click)="mobileMenu.toggle()">
            <cl-icon
              [icon]="mobileMenu.opened ? Icon.cancel : Icon.menuTabs"
              size="44px" />
          </button>
        </div>
      </header>
      <mat-sidenav-container>
        <mat-sidenav
          [fixedTopGap]="0"
          fixedInViewport
          #drawer
          mode="over"
          [autoFocus]="false"
          class="sidenav--left"
          (opened)="disableScroll()"
          (closed)="enableScroll()">
          <ng-template [cdkPortalOutlet]="sidenavService.panelPortal | async" />
        </mat-sidenav>
        <div
          [class.left]="(tabPosition$ | async) === 'left'"
          class="page-content">
          <ng-template #header>
            <nav
              class="tabs"
              [attr.aria-label]="'Main Menu' | translate">
              <div class="header-mobile-menu">
                <div
                  class="header__logged-in-user"
                  data-private
                  id="logged-in-user-menu">
                  <ng-container *ngTemplateOutlet="UserNameBlock" />
                </div>
                @if (orgCode$ | async; as orgCode) {
                  <div class="header__logged-in-user__bottom__org-code">
                    <div class="header__logged-in-user__bottom__org-code__label">
                      {{ 'Org Code:' | translate }}
                    </div>
                    <div class="header__logged-in-user__bottom__org-code__value">{{ orgCode }}</div>
                  </div>
                }
              </div>
              <ul
                class="nav"
                id="nav">
                <li class="nav__item">
                  @if (isDisplayed('TEACHER_HOME')) {
                    <a
                      [routerLink]="['teacher-home']"
                      [class.selected]="isSelected('TEACHER_HOME')"
                      [attr.aria-current]="isSelected('TEACHER_HOME') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.house"
                        [newItemsCount]="notificationCount('TEACHER_HOME') | async"
                        [selected]="isSelected('TEACHER_HOME')">
                        {{ tabTitles.get(Tabs.TEACHER_HOME) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('ADMIN_HOME')) {
                    <a
                      [routerLink]="['admin-home']"
                      [class.selected]="isSelected('ADMIN_HOME')"
                      [attr.aria-current]="isSelected('ADMIN_HOME') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.house"
                        [newItemsCount]="notificationCount('ADMIN_HOME') | async"
                        [selected]="isSelected('ADMIN_HOME')">
                        {{ tabTitles.get(Tabs.ADMIN_HOME) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('ACCOUNTS')) {
                    <a
                      [routerLink]="['accounts']"
                      [class.selected]="isSelected('ACCOUNTS')"
                      [attr.aria-current]="isSelected('ACCOUNTS') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.keyLabel"
                        [newItemsCount]="notificationCount('ACCOUNTS') | async"
                        [selected]="isSelected('ACCOUNTS')">
                        {{ tabTitles.get(Tabs.ACCOUNTS) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('CONFIGURATION')) {
                    <a
                      [routerLink]="['configuration']"
                      [class.selected]="isSelected('CONFIGURATION')"
                      [attr.aria-current]="isSelected('CONFIGURATION') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.configure"
                        [newItemsCount]="notificationCount('CONFIGURATION') | async"
                        [selected]="isSelected('CONFIGURATION')">
                        {{ tabTitles.get(Tabs.CONFIGURATION) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('TEACHER_DASHBOARDS')) {
                    <a
                      [routerLink]="['teacher-dashboards']"
                      [class.selected]="isSelected('TEACHER_DASHBOARDS')"
                      [attr.aria-current]="isSelected('TEACHER_DASHBOARDS') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.dashboards"
                        [newItemsCount]="notificationCount('TEACHER_DASHBOARDS') | async"
                        [selected]="isSelected('TEACHER_DASHBOARDS')">
                        {{ tabTitles.get(Tabs.TEACHER_DASHBOARDS) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('REPORTS')) {
                    <a
                      [routerLink]="['reports']"
                      [class.selected]="isSelected('REPORTS')"
                      [attr.aria-current]="isSelected('REPORTS') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.report"
                        [newItemsCount]="notificationCount('REPORTS') | async"
                        [selected]="isSelected('REPORTS')">
                        {{ tabTitles.get(Tabs.REPORTS) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('ORGANIZATIONS')) {
                    <a
                      [routerLink]="['organizations']"
                      [class.selected]="isSelected('ORGANIZATIONS')"
                      [attr.aria-current]="isSelected('ORGANIZATIONS') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.school"
                        [newItemsCount]="notificationCount('ORGANIZATIONS') | async"
                        [selected]="isSelected('ORGANIZATIONS')">
                        {{ tabTitles.get(Tabs.ORGANIZATIONS) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('TEACHER_USERS')) {
                    <a
                      [routerLink]="['teacher-users']"
                      [class.selected]="isSelected('TEACHER_USERS')"
                      [attr.aria-current]="isSelected('TEACHER_USERS') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.students"
                        [newItemsCount]="notificationCount('TEACHER_USERS') | async"
                        [selected]="isSelected('TEACHER_USERS')">
                        {{ tabTitles.get(Tabs.TEACHER_USERS) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('GOALS')) {
                    <a
                      [routerLink]="['goals']"
                      [class.selected]="isSelected('GOALS')"
                      [attr.aria-current]="isSelected('GOALS') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.blackboard"
                        [newItemsCount]="notificationCount('GOALS') | async"
                        [selected]="isSelected('GOALS')">
                        {{ tabTitles.get(Tabs.GOALS) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('ASSESSMENTS')) {
                    <a
                      [routerLink]="['assessments']"
                      [class.selected]="isSelected('ASSESSMENTS')"
                      [attr.aria-current]="isSelected('ASSESSMENTS') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.scale"
                        [selected]="isSelected('ASSESSMENTS')">
                        {{ tabTitles.get(Tabs.ASSESSMENTS) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('ACTIVITIES')) {
                    <a
                      [routerLink]="
                        (isPlaylistAdmin$ | async) ? ['activities', 'playlists'] : ['activities']
                      "
                      [class.selected]="isSelected('ACTIVITIES')"
                      [attr.aria-current]="isSelected('ACTIVITIES') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.puzzle"
                        [newItemsCount]="notificationCount('ACTIVITIES') | async"
                        [selected]="isSelected('ACTIVITIES')">
                        {{ tabTitles.get(Tabs.ACTIVITIES) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('NOTIFICATIONS_MANAGER')) {
                    <a
                      [routerLink]="['notifications-manager']"
                      [class.selected]="isSelected('NOTIFICATIONS_MANAGER')"
                      [attr.aria-current]="isSelected('NOTIFICATIONS_MANAGER') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.bellRed"
                        [newItemsCount]="notificationCount('NOTIFICATIONS_MANAGER') | async"
                        [selected]="isSelected('NOTIFICATIONS_MANAGER')">
                        {{ tabTitles.get(Tabs.NOTIFICATIONS_MANAGER) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('MESSAGES_AND_NOTIFICATIONS')) {
                    <a
                      [routerLink]="['messages-and-notifications']"
                      [class.selected]="isSelected('MESSAGES_AND_NOTIFICATIONS')"
                      [attr.aria-current]="
                        isSelected('MESSAGES_AND_NOTIFICATIONS') ? 'page' : null
                      ">
                      <cl-nav-item
                        [icon]="Icon.email"
                        [newItemsCount]="notificationCount('MESSAGES_AND_NOTIFICATIONS') | async"
                        [selected]="isSelected('MESSAGES_AND_NOTIFICATIONS')">
                        {{ tabTitles.get(Tabs.MESSAGES_AND_NOTIFICATIONS) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('FAMILIES')) {
                    <a
                      [routerLink]="['families']"
                      [class.selected]="isSelected('FAMILIES')"
                      [attr.aria-current]="isSelected('FAMILIES') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.families"
                        [newItemsCount]="notificationCount('FAMILIES') | async"
                        [selected]="isSelected('FAMILIES')">
                        {{ tabTitles.get(Tabs.FAMILIES) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <li class="nav__item">
                  @if (isDisplayed('PROFILE')) {
                    <a
                      [routerLink]="['profile']"
                      [class.selected]="isSelected('PROFILE')"
                      [attr.aria-current]="isSelected('PROFILE') ? 'page' : null">
                      <cl-nav-item
                        [icon]="Icon.user"
                        [newItemsCount]="notificationCount('PROFILE') | async"
                        [selected]="isSelected('PROFILE')">
                        {{ tabTitles.get(Tabs.PROFILE) | async }}
                      </cl-nav-item>
                    </a>
                  }
                </li>
                <div class="nav__item">
                  <cl-btn
                    icon="logout"
                    (click)="logOut()"
                    buttonStyle="primary"
                    id="logout-button-menu">
                    {{ 'Logout' | translate }}
                  </cl-btn>
                </div>
              </ul>
            </nav>
          </ng-template>
          <div class="desktop-nav">
            <ng-container *ngTemplateOutlet="header" />
          </div>
          <router-outlet />
        </div>
      </mat-sidenav-container>
      <footer
        class="footer"
        id="site-footer">
        <div class="footer__copyright">Copyright © Waterford.org</div>
        <a
          class="footer__license-agreement"
          href="https://www.waterford.org/eula/"
          rel="noopener noreferrer"
          target="_blank">
          {{ 'Terms of Service' | translate }}
        </a>
        <a
          class="footer__privacy-policy"
          href="https://www.waterford.org/privacy-policy/"
          rel="noopener noreferrer"
          target="_blank">
          {{ 'Privacy Policy' | translate }}
        </a>
      </footer>
    </mat-sidenav-container>
  </div>
</div>

@if (!isPrintingRoute) {
  <help-widget [tabTitles]="tabTitles" />
}

<ng-template #UserNameBlock>
  {{ loggedInUser?.name }}
</ng-template>
